import { createSlice } from '@reduxjs/toolkit';

export interface MobileNavigationState {
    settings: {
        [key: string]: string;
    } | null;
}

const initialState: MobileNavigationState = {
    settings: null
};

const mobileNavigationSlice = createSlice({
    name: 'mobileNavigation',
    initialState,
    reducers: {
        setMobileNavigationSettings: (state, action) => {
            state.settings = action.payload;
        }
    }
});

export const mobileNavigationStore = { mobile_navigation: mobileNavigationSlice.reducer };
export const { setMobileNavigationSettings } = mobileNavigationSlice.actions;
